import React from 'react'
import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import posthog from 'posthog-js'
import { addOnlinePayForOther } from 'services/easyPay'

export default function useGetFuckHamyan() {
    const navigate = useNavigate()
    const { mutate } = useMutation({
        mutationFn: (payload: IAddOnlinePayForOtherPayload) => {
            return addOnlinePayForOther(payload)
        },
        onSuccess: (result, variables) => {
            posthog.capture('payforother_registered', { amount: (variables as any)?.amount, moneypool_id: (variables as any)?.moneyPool })
            navigate('/funds')
        },
        onError: () => {
            posthog.capture('payforother_register_failed')
            toast.error('مشکلی پیش آمده!')
            navigate('/funds')
        },
    })
    return { mutate }
}
